import React from 'react';
import { CheckCircle, ArrowLeft } from 'lucide-react';

const DonationSuccess = ({ donationData, onBackToHome }) => {
  const handleBackToHome = () => {
    if (onBackToHome) {
      onBackToHome();
    } else {
      window.location.href = '/';
    }
  };

  return (
    <div className="min-h-screen bg-[#FFF8E6] flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-8 text-center">
        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <CheckCircle className="h-16 w-16 text-green-500" />
        </div>

        {/* Success Message */}
        <h1 className="text-2xl font-source-serif-4 font-semibold text-[#67142D] mb-4">
          Thank You for Your Donation!
        </h1>
        
        <p className="text-gray-600 mb-6">
          Your generous contribution will help us continue our mission of spreading light through education, healthcare, and spiritual guidance.
        </p>

        {/* Donation Details */}
        {donationData && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-gray-800 mb-2">Donation Details</h3>
            <p className="text-sm text-gray-600">
              <span className="font-medium">Amount:</span> ₹{donationData.amount}
            </p>
            <p className="text-sm text-gray-600">
              <span className="font-medium">Order ID:</span> {donationData.orderId}
            </p>
          </div>
        )}

        {/* Confirmation Message */}
        {/* <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
          <p className="text-green-800 text-sm">
            A confirmation email has been sent to your registered email address. 
            You will also receive a receipt for your donation.
          </p>
        </div> */}

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleBackToHome}
            className="w-full bg-[#67142D] text-white py-3 px-6 rounded-lg hover:bg-[#B51F3B] transition-colors flex items-center justify-center"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </button>
          
          <button
            onClick={() => window.print()}
            className="w-full border border-gray-300 text-gray-700 py-3 px-6 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Print Receipt
          </button>
        </div>

        {/* Additional Information */}
        <div className="mt-8 text-xs text-gray-500">
          <p>
            For any queries regarding your donation, please contact us at 
            <a href="mailto:support@vishwasanatan.org" className="text-[#67142D] hover:underline ml-1">
              support@vishwasanatan.org
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DonationSuccess;
